import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { ReactElement } from 'react';
import { HStack } from './h-stack';
import { Text } from './text';
type BreadcrumbItem = {
  label: string;
  href?: string;
};
type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};
const renderCrumb = ({
  label,
  href
}: BreadcrumbItem, isCurrent: boolean): ReactElement => {
  if (isCurrent) {
    return <Text as="span" variant="body" aria-current="page" className="font-medium">
        {label}
      </Text>;
  }
  if (href) {
    return <Link href={href}>
        <Text as="span" variant="body" tone="secondary" className="transition-colors hover:text-fg">
          {label}
        </Text>
      </Link>;
  }
  return <Text as="span" variant="body" tone="secondary">
      {label}
    </Text>;
};

/** A trail of page links, e.g. "Settings / Account / Branding". The last item renders as the current page (no link); items with no `href` render as plain text. */
export const Breadcrumbs = t0 => {
  const $ = _c(6);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    let t2;
    if ($[2] !== items.length) {
      t2 = (item, index) => <HStack as="li" key={`${index}-${item.label}`} align="center" gap={2}>{index > 0 && <Text as="span" variant="body" tone="secondary" aria-hidden={true}>/</Text>}{renderCrumb(item, index === items.length - 1)}</HStack>;
      $[2] = items.length;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <nav aria-label="Breadcrumb"><HStack as="ol" align="center" gap={2}>{t1}</HStack></nav>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};